import Guards from './guards'

import Policies from '../components/copy'
import Views from '../views'

export default [
    {
        path: '/test/',
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        beforeEnter: Guards.requireNonProductionEnvironment,
        children: [
            {
                path: 'components',
                name: 'Components',
                component: Views.Test.Components,
                invalidForRedirect: true,
                static: true,
            },
        ],
    },
    {
        path: '/policies/',
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: 'cookies',
                name: 'CookiePolicyViewer',
                props: {
                    policy: Policies.Cookies,
                    title: 'Cookies & Local Data Policy',
                },
                component: Views.PolicyWrapper,
                invalidForRedirect: true,
                static: true,
            },
            {
                path: 'privacy',
                name: 'PrivacyPolicyViewer',
                props: {
                    policy: Policies.Privacy,
                    title: 'Privacy Notice',
                },
                component: Views.PolicyWrapper,
                invalidForRedirect: true,
                static: true,
            },
            {
                path: 'terms',
                name: 'TermsViewer',
                props: {
                    policy: Policies.TermsAndConditions,
                    title: 'Terms & Conditions',
                },
                component: Views.PolicyWrapper,
                invalidForRedirect: true,
                static: true,
            },
            {
                path: 'cookie-consent',
                name: 'CookieConsent',
                props: true,
                component: Views.CookieConsent,
                invalidForRedirect: true,
            },
        ],
    },
    {
        path: '/',
        props: true,
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        beforeEnter: Guards.requireCookieConsent,
        children: [
            {
                path: '',
                name: 'Welcome',
                component: Views.Welcome,
                invalidForRedirect: true,
                beforeEnter: Guards.disallowExternal,
            },
            {
                path: 'search',
                name: 'Search',
                component: Views.Search,
                invalidForRedirect: false,
            },
            {
                path: 'verify-guest',
                name: 'ReCaptcha',
                component: Views.ReCaptcha,
                invalidForRedirect: true,
                beforeEnter: Guards.requireGuest,
            },
            {
                path: 'login',
                name: 'LogIn',
                props: true,
                component: Views.LogIn,
                backFlowExclude: true,
                beforeEnter: Guards.disallowExternal,
            },
            {
                path: 'login',
                name: 'LogInFromSubnav',
                props: true,
                component: Views.LogIn,
                backFlowExclude: true,
                beforeEnter: Guards.disallowExternal,
            },
            {
                path: 'external-user-login',
                name: 'ExternalUserLogin',
                component: Views.ExternalUserLogin,
            },
            {
                path: 'login-user',
                name: 'LogInWithContext',
                props: true,
                component: Views.LogIn,
                backFlowExclude: true,
                beforeEnter: Guards.disallowExternal,
            },
            {
                path: 'register',
                name: 'Register',
                props: true,
                component: Views.Registration,
                backFlowExclude: true,
                beforeEnter: Guards.multiple([
                    Guards.requireGuest, Guards.requireSelectedProperty, Guards.disallowExternal,
                ]),
            },
            {
                path: 'reset-pw',
                name: 'ResetPassword',
                backFlowExclude: true,
                component: Views.ResetPassword,
                static: true,
                beforeEnter: Guards.disallowExternal,
            },
            {
                path: 'choose-address',
                name: 'AddressChooser',
                component: Views.AddressChooser,
                invalidForRedirect: true,
                beforeEnter: Guards.requireUserOrReCaptcha,
            },
            {
                path: 'context-viewer',
                name: 'ContextViewer',
                component: Views.ContextViewer,
                invalidForRedirect: true,
                static: true,
            },
        ],
    },
    {
        path: '/address',
        props: true,
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: '',
                name: 'MyHome',
                props: {
                    segment: null,
                },
                component: Views.MyHome.Summary,
                beforeEnter: Guards.multiple([
                    Guards.requireUserOrReCaptcha, Guards.requireSelectedProperty,
                ]),
            },
            {
                path: 'edit',
                name: 'MyHomeEdit',
                canReuse: false,
                component: Views.MyHome.Edit,
                backFlowExclude: true,
                beforeEnter: Guards.multiple([
                    Guards.requireUser, Guards.requireSelectedProperty,
                ]),
            },
        ],
    },
    {
        path: '/address',
        props: { showPolicies: false },
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: 'error/:title/:text',
                name: 'ProgressErrorMessage',
                props: {
                    showOk: false,
                    showBack: true,
                    isError: true,
                },
                component: Views.Message,
            },
        ],
    },
    {
        path: '/',
        props: { showPolicies: false },
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: 'plan/choose',
                name: 'PlanChooser',
                props: true,
                component: Views.Plan.Chooser,
                beforeEnter: Guards.multiple([
                    Guards.requireUserOrReCaptcha, Guards.requireSelectedProperty,
                ]),
            },
        ],
    },
    {
        path: '/plan',
        props: true,
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: 'review',
                name: 'PlanSummaryReview',
                props: true,
                component: Views.Plan.SummaryReview,
                beforeEnter: Guards.multiple([
                    Guards.requireUserOrReCaptcha, Guards.requireSelectedProperty, Guards.requireCurrentProject,
                ]),
            },
            {
                path: 'notes',
                name: 'PlanNotesForm',
                props: true,
                component: Views.Plan.NotesForm,
                beforeEnter: Guards.multiple([
                    Guards.requireUserOrReCaptcha, Guards.requireSelectedProperty, Guards.requireCurrentProject, Guards.requireNonLiteScheme,
                ]),
            },
            {
                path: 'proceed',
                name: 'GoAhead',
                props: {
                    text: 'You have selected to proceed with the following renovation project...',
                },
                component: Views.GoAhead,
                forcesUser: true,
                beforeEnter: Guards.multiple([
                    Guards.requireUser, Guards.requireSelectedProperty, Guards.requireCurrentProject,
                ]),
            },
            {
                path: 'services',
                name: 'PlanServices',
                component: Views.Plan.Services,
                beforeEnter: Guards.multiple([
                    Guards.requireUser, Guards.requireSelectedProperty, Guards.requireCurrentProject, Guards.requireSchemeServicesOffering,
                ]),
                static: true,
            },
        ],
    },
    {
        path: '/',
        props: true,
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: 'plan/build',
                name: 'PlanBuilder',
                props: true,
                component: Views.Plan.Builder,
                beforeEnter: Guards.multiple([
                    Guards.requireUserOrReCaptcha, Guards.requireSelectedProperty, Guards.requireCurrentProjectParameters,
                ]),
            },
        ],
    },
    {
        path: '/service-basket',
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: 'home-energy-plan',
                name: 'HomeEnergyPlan',
                component: Views.ServiceBasket.HomeEnergyPlan,
            },
            {
                path: 'financial-services',
                name: 'FinancialServices',
                component: Views.ServiceBasket.FinancialServices,
            },
            {
                path: 'basket-summary',
                name: 'BasketSummary',
                component: Views.ServiceBasket.BasketSummary,
            },
        ],
    },
    {
        path: '/user',
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        beforeEnter: Guards.requireLoggedInUser,
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Views.User.Dashboard,
            },
            {
                path: 'profile',
                name: 'MyAccount',
                component: Views.User.MyAccount,
                beforeEnter: Guards.disallowExternal,
            },
        ],
    },
    {
        path: '/app',
        redirect: '/',
    },
    {
        path: '/app/*',
        redirect: '/',
    },
    {
        path: '*',
        components: {
            default: Views.Pages.Flow,
            header: Views.Headers.Main,
        },
        children: [
            {
                path: '',
                name: 'NotFound',
                props: {
                    title: 'Not Found',
                    text: `The path you have entered doesn't have any content`,
                },
                component: Views.Message,
                invalidForRedirect: true,
                static: true,
            },
        ],
    },
]
